import { objectOf } from "@altostra/type-validations";

export const isPatchCanvasStepPositionResult = objectOf({
  /** @todo */
});
